export default __webpack_public_path__ + "static/media/rabbit-left.1860b66e.png";